import React from "react";
import { Alert, Typography } from "@mui/material";
import { LEGAL_COPY_AI_ASSISTANT_INPUT_NOTICE } from "@healthdesk/shared-utils";

/**
 * Outlined warning-style notice for Ask Me Anything / Query Chat surfaces.
 * Intended to sit below the message input.
 * @param {Object} props
 * @param {boolean} [props.dense] - Slightly smaller type on compact layouts
 * @param {Object} [props.sx] - MUI sx on the Alert root
 */
function AiAssistantDisclaimer({ dense = false, sx = {} }) {
  return (
    <Alert severity="warning" variant="outlined" icon={false} sx={{ mb: 0, ...sx }}>
      <Typography
        variant="body2"
        component="p"
        sx={{
          m: 0,
          ...(dense ? { fontSize: "0.8125rem", lineHeight: 1.45 } : {}),
        }}
      >
        {LEGAL_COPY_AI_ASSISTANT_INPUT_NOTICE}
      </Typography>
    </Alert>
  );
}

export default AiAssistantDisclaimer;
